import { BlogPostContent } from '@/types/blog';
import { introSection } from './sections/intro';
import { wachstumSection } from './sections/wachstum';
import { emotionaleIntelligenzSection } from './sections/emotionale-intelligenz';
import { sicherheitSection } from './sections/sicherheit';
import { menschBleibtSection } from './sections/mensch-bleibt';
import { fazitSection } from './sections/fazit';

export const content: BlogPostContent = {
  sections: [
    introSection,
    wachstumSection,
    emotionaleIntelligenzSection,
    sicherheitSection,
    menschBleibtSection,
    fazitSection
  ]
};
